import { ComponentProps, CSSProperties, ReactElement } from 'react';
import { TabPane } from './tab-pane';

export type TabContentProps = {
  panes: ReactElement<ComponentProps<typeof TabPane>>[];
  activeKey: string;
  activatedKeyList: string[];
  tabsType?: 'freedom' | 'fixed';
  lazyLoad?: boolean;
};
const classPrefix = `v-tabs`;

export const TabContent = (props: TabContentProps) => {
  const isFixed = props.tabsType === 'fixed';

  return (
    <div className={`${classPrefix}-content`}>
      {props.panes.map((pane) => {
        if (pane.props.children === undefined) {
          return null;
        }
        const isActive = pane.key === props.activeKey;
        if (props.lazyLoad && !props.activatedKeyList.includes(pane.key as string)) {
          return null;
        }
        let contentItemStyle = {} as CSSProperties;

        if (isActive) {
          if (isFixed) {
            contentItemStyle = {
              ...contentItemStyle,
              transform: 'translateX(0%)',
              WebkitTransform: 'translateX(0%)',
            };
          }
        } else {
          if (!isFixed) {
            contentItemStyle.display = 'none';
          }
        }

        return (
          <div key={pane.key} className={`${classPrefix}-content-item`} style={contentItemStyle}>
            {pane.props.children}
          </div>
        );
      })}
    </div>
  );
};
